import React from 'react';

import LegacyWatchedIcon from '@atlaskit/icon/core/migration/eye-open-filled--watch-filled';
import LegacyUnwatchedIcon from '@atlaskit/icon/core/migration/eye-open--watch';
import WatchedIcon from '@atlaskit/icon/core/eye-open-filled';
import UnwatchedIcon from '@atlaskit/icon/core/eye-open';

type WatchIconProps = {
	isWatched: boolean;
	size?: 'small' | 'medium';
	legacy?: boolean;
};

export const WatchIcon = ({ isWatched, size = 'medium', legacy = false }: WatchIconProps) => {
	if (legacy) {
		return isWatched ? (
			<LegacyWatchedIcon label="" LEGACY_size={size} />
		) : (
			<LegacyUnwatchedIcon label="" LEGACY_size={size} />
		);
	}

	return isWatched ? (
		<WatchedIcon label="" color="currentColor" LEGACY_size={size} />
	) : (
		<UnwatchedIcon label="" color="currentColor" LEGACY_size={size} />
	);
};
